export const inputSx = {
  '& .MuiOutlinedInput-root': {
    fontSize: '13px',
    borderRadius: '7px',
    background: '#fff',
    '& fieldset': { borderColor: '#d1d5db' },
    '&:hover fieldset': { borderColor: '#9ca3af' },
    '&.Mui-focused fieldset': { borderColor: '#2563eb', borderWidth: '1.5px' },
  },
  '& .MuiInputBase-input::placeholder': { color: '#9ca3af', opacity: 1 },
};

export const disabledInputSx = {
  ...inputSx,
  '& .MuiOutlinedInput-root': {
    ...inputSx['& .MuiOutlinedInput-root'],
    background: '#f9fafb',
  },
};

export const PLAN_TYPES = {
  ASSESSMENT: 'assessment',
  SINGLE:     'single',
  BUNDLE:     'bundle',
  B2B:        'b2b',
};

export const ASSESSMENT_TYPES = [
  { key: 'FULL_TEST',    label: 'Full Tests',    subtitle: 'Complete mock exams' },
  { key: 'SUBJECT_TEST', label: 'Subject Tests', subtitle: 'Single-subject assessments' },
  { key: 'CHAPTER_TEST', label: 'Chapter Tests', subtitle: 'Topic-level short tests' },
];